import { useState } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function DeleteAccountDialog({ account, open, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const isLive = !account?.is_demo;

  const confirm = async () => {
    if (!account) return;
    setBusy(true);
    try {
      await api.delete(`/accounts/${account.account_id}`);
      toast.success(`"${account.name}" disconnected and removed`);
      onClose();
      onDeleted?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't remove account");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent data-testid="delete-account-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">Disconnect and delete &ldquo;{account?.name}&rdquo;?</AlertDialogTitle>
          <AlertDialogDescription className="text-xs leading-relaxed">
            {isLive
              ? "This stops the live sync with your broker, removes the account from MetaApi, and deletes all its imported trade history, analytics and share links from My Trading Room. Your real trading account at the broker is not affected. You can reconnect it later with your investor password."
              : "This removes the account and all its history from My Trading Room."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid="delete-account-cancel">Keep account</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); confirm(); }} disabled={busy}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid="delete-account-confirm">
            {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : null} Disconnect and delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
